// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timer-progress {
  margin-left: 10px;
}
.timer-progress .ant-progress-circle-path {
  stroke: #25B2D4 !important;
}
.timer-title {
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: #00000080;
  margin-bottom: 2px;
}
.timer-countDown {
  font-size: 20px;
  font-weight: 700;
  line-height: 1;
  color: #000000;
}
@media screen and (max-width: 452px) {
  .timer-progress {
    margin-left: unset;
  }
  .timer-progress .ant-progress-inner {
    width: 32px !important;
    height: 32px !important;
  }
  .timer-title {
    font-size: 14px;
    font-weight: 400;
    line-height: 1;
    color: #00000080;
    margin-bottom: 2px;
  }
  .timer-countDown {
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/cashier/endTime/style.less"],"names":[],"mappings":"AAEE;EACI,iBAAA;AADN;AAAE;EAIQ,0BAAA;AADV;AAKE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAHJ;AAME;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAJJ;AAQA;EAEI;IACE,kBAAA;EAPJ;EAME;IAII,sBAAA;IACA,uBAAA;EAPN;EAWE;IACE,eAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;IACA,kBAAA;EATJ;EAYE;IACE,eAAA;IACA,gBAAA;IACA,iBAAA;EAVJ;AACF","sourcesContent":["\n.timer {\n  &-progress {\n      margin-left: 10px;\n\n      .ant-progress-circle-path {\n          stroke: #25B2D4 !important;\n      }\n  }\n\n  &-title {\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 1;\n    color: #00000080;\n    margin-bottom: 2px;\n  }\n\n  &-countDown {\n    font-size: 20px;\n    font-weight: 700;\n    line-height: 1;\n    color: #000000;\n  }\n}\n\n@media screen and (max-width: 452px) {\n  .timer {\n    &-progress {\n      margin-left: unset;\n\n      .ant-progress-inner {\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n\n    &-title {\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 1;\n      color: #00000080;\n      margin-bottom: 2px;\n    }\n\n    &-countDown {\n      font-size: 18px;\n      font-weight: 600;\n      line-height: 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
